import { Skeleton } from "components";
import {
  ContainerSkeletonTagLine,
  ContainerBoxSkeleton,
  ButtonSkeleton,
  BoxMobile,
  BoxDesktop,
} from "./styles";

const SkeletonProduct = () => {
  const skeletonFakeList = [0, 1, 2, 3, 4];

  return (
    <>
      <section>
        <ContainerBoxSkeleton responsiveOrder={2}>
          {skeletonFakeList.map((skeletonFakeItem) => (
            <Skeleton key={skeletonFakeItem} count={1} height={40} width={40} />
          ))}
        </ContainerBoxSkeleton>
        <ContainerBoxSkeleton responsiveOrder={1}>
          <BoxMobile>
            <Skeleton count={1} height="35rem" width="35rem" />
          </BoxMobile>
          <BoxDesktop>
            <Skeleton count={1} height="45rem" width="45rem" />
          </BoxDesktop>
        </ContainerBoxSkeleton>
      </section>
      <section>
        <ContainerSkeletonTagLine maxHeight="9rem">
          <Skeleton count={2} height={40} width="40rem" />
        </ContainerSkeletonTagLine>
        <ContainerSkeletonTagLine maxHeight="3rem">
          <Skeleton count={1} height={20} width="25rem" />
        </ContainerSkeletonTagLine>

        <ContainerSkeletonTagLine maxHeight="3rem">
          <Skeleton count={1} height={20} width="15rem" />
        </ContainerSkeletonTagLine>
        <ContainerSkeletonTagLine maxHeight="3rem">
          <Skeleton count={1} height={50} width="10rem" />
        </ContainerSkeletonTagLine>
        <ContainerSkeletonTagLine maxHeight="3rem">
          <Skeleton count={1} height={20} width="20rem" />
        </ContainerSkeletonTagLine>

        <ButtonSkeleton>
          <Skeleton count={1} height={100} width="40rem" />
        </ButtonSkeleton>

        <ContainerSkeletonTagLine>
          <ContainerSkeletonTagLine>
            <Skeleton count={2} height={25} width="15rem" />
          </ContainerSkeletonTagLine>
          <Skeleton count={1} height="5rem" width="15rem" />
        </ContainerSkeletonTagLine>
      </section>
    </>
  );
};

export default SkeletonProduct;
